__turbopack_context__.v({
  "active": "ChatTextarea-module-scss-module__McmMgW__active",
  "active_background": "ChatTextarea-module-scss-module__McmMgW__active_background",
  "chat_button": "ChatTextarea-module-scss-module__McmMgW__chat_button",
  "loading": "ChatTextarea-module-scss-module__McmMgW__loading",
  "loading_background": "ChatTextarea-module-scss-module__McmMgW__loading_background",
});
